import React from 'react';
import NavbarComponent from '../pages/Navbar'; // ✅ fixed path
import Footer from '../Footer'; 
import ContactUsSection from './ContactUsSection';
 import ContactUsBanner from './ContactUsBanner';
const ContactUs = () => {
  return (
    <>
      <NavbarComponent />
   

<ContactUsBanner />

     <ContactUsSection/>
       
      <Footer />
    </>
  );
};

export default ContactUs;
